package com.downdogapp.client.views.start

import com.downdogapp.client.View
import com.downdogapp.client.controllers.start.Page

expect class StartView() : View {

  fun refreshView()
  fun showSpinner()
  fun hideSpinner()
  fun goToPage(page: Page)
  fun hideLoadingOverlay()
  fun setTabBarOpacity(value: Number)
}

object StartViewConstants {

  val TAB_BAR_HEIGHT = 50
}

